<template>
	<modal ref="modal">
		<template #title>
			<span v-if="txnRequest">{{ `Follow Up: ${txnRequest.fullname}` }}</span>
		</template>
		<template #body>
			<div v-if="txnRequest">
				<p class="mb-2 border p-4 py-2 px-3">{{ txnRequest.txnid }}</p>
				<p class="mb-2 border p-4 py-2 px-3">{{ txnRequest.fullname }}</p>
				<p class="mb-2 border p-4 py-2 px-3">{{ txnRequest.mobile }}</p>
				<p class="mb-2 border p-4 py-2 px-3">{{ txnRequest.course }}</p>
				<p class="mb-2 border p-4 py-2 px-3">
					{{ `${txnRequest.mop}: ${txnRequest.amount}` }}
				</p>
				<p class="mb-2 border p-4 py-2 px-3">{{ txnRequest.status }}</p>
				<div class="mb-4">
					<label for="status" class="form-label">Enter Status</label>
					<select
						v-model="form.status"
						class="form-select"
						:class="{ 'is-invalid': form.errors.status }"
						id="status"
					>
						<option value="change of mind">Change of Mind</option>
						<option value="will purchase later">Will purchase later</option>
						<option value="call rejected">Call Rejected</option>
						<option value="no response">No Response</option>
					</select>
					<div v-if="form.errors.status" class="invalid-feedback">
						{{ form.errors.status }}
					</div>
				</div>
				<div class="mb-4">
					<label
						for="remarks"
						class="form-label"
						:class="{ 'is-invalid': form.errors.remarks }"
						>Follow-up Remarks</label
					>
					<textarea
						v-model="form.remarks"
						class="form-control"
						row="5"
					></textarea>
					<div v-if="form.errors.remarks" class="invalid-feedback">
						{{ form.errors.remarks }}
					</div>
				</div>
			</div>
		</template>
		<template #footer>
			<button
				@click="followUp"
				type="button"
				class="btn btn-alt-primary"
				:disabled="form.processing"
			>
				Follow Up
			</button>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3'
import { ref, toRef, toRefs, watch } from 'vue'

export default {
	props: {
		txnRequest: {
			type: Object,
			default: null,
		},
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const form = useForm({
			ops_request_id: null,
			email: null,
			status: null,
			remarks: null,
		})

		const followUp = () => {
			form.post(route('admin.transactions.post.abandoned-followup'), {
				preserveState: true,
				preserveScroll: true,
				onSuccess: () => {
					form.reset('status', 'remarks')
					toggleModal()
				},
			})
		}

		watch(
			() => props.txnRequest,
			(request) => {
				if (request) {
					form.ops_request_id = request.counter
					form.email = request.email
				}
			}
		)

		return {
			modal,
			form,
			followUp,
			toggleModal,
		}
	},
}
</script>
